import {useAuth} from "react-oidc-context";

export function useBearerToken(): string | undefined {
	const auth = useAuth();
	return auth.isAuthenticated ? auth.user?.access_token : undefined;
}
